import React from "react";
import cvData from "../../data/cv";

const skillsIntro =
  "Native iOS first — with architecture, backend, and delivery skills to ship and maintain production apps.";

const Skills = () => {
  return (
    <section className="colorlib-skills" data-section="skills" id="skills">
      <div className="colorlib-narrow-content">
        <div className="row">
          <div
            className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box"
            data-animate-effect="fadeInLeft"
          >
            <span className="heading-meta">My Specialty</span>
            <h2 className="colorlib-heading animate-box">My Skills</h2>
          </div>
        </div>
        <div className="row">
          <div
            className="col-md-12 animate-box"
            data-animate-effect="fadeInLeft"
          >
            <p className="skills-intro">{skillsIntro}</p>
          </div>
          <div
            className="col-md-12 animate-box"
            data-animate-effect="fadeInUp"
          >
            <div className="skills-compact-list">
              {cvData.technicalSkills.map((group) => (
                <div key={group.category} className="skills-compact-row">
                  <h3 className="skills-compact-title">{group.category}</h3>
                  <ul className="skills-chip-list">
                    {group.items.map((skill) => (
                      <li key={skill} className="skills-chip">
                        {skill}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Skills;
